define('TescoMobile_Catalog/js/view/full-overview',['jquery', 'underscore', 'TescoMobile_Catalog/js/action/full-overview-load', 'lazyLoadBgImg'], function ($, _, getFullOverview, lazyLoadBgImg) {
  'use strict';

  return function () {
    var widget = widget || {};
    widget.fullOverview = {
      init: function () {
        const sku = $("#product_addtocart_form").data('product-sku');
        this.loadOverview(sku);
      },
      loadOverview: function (sku) {
        var deferred = $.Deferred(),
          _self = this;
        getFullOverview(deferred, sku);
        $.when(deferred).done(function (response) {
          if (response) {
            _self.appendFullOverview(response);
          }
          return true;
        }).fail(function (response) {
          console.log(response);
        });
      },
      appendFullOverview: function (response) {
        let html = JSON.parse(response);
        let fullOverview = $('<div/>').html(_.unescape(html).replaceAll('&nbsp;', ' '));
        $('.attribute.description .value').append(fullOverview);
        $(window).trigger('resize');
        lazyLoadBgImg();
      }
    };
    widget.fullOverview.init();
  };
});

